import React, { PropsWithChildren, ReactElement } from "react";

import { classNames } from "../../../utils/classes";

type Props = {
  classNames?: string;
};

export default function PanelFooter(
  props: PropsWithChildren<Props>,
): ReactElement {
  const { children } = props;

  return <div className={classNames(props.classNames || "")}>{children}</div>;
}
